import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { Page } from 'shared/ui/Page';
import getEnvConfig from 'utils/config/env';

import { getTabs } from '../utils/tabs';
import { useAppSelector } from '../../../store';
import { selectShopCurrent } from '../../shops/features/shops/store/shopSlice';
import { ShopSelector } from '../../shops/features/shops/components/ShopSelector';
import { ExampleShopCard } from '../../shops/features/shops/components/ExampleShopCard';
import { useProfileData } from '../../../hooks/useProfileData';
import { useLazyReadShopsQuery } from '../../shops/features/shops/service/shops';
import { Shop } from '../../shops/features/shops/service/shop.interface';
import { shopsFilters } from '../../shops/features/shops/utils/shopList.filters';

const pageSlug = 'crm-current-page';

export const CrmPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useProfileData();
    const [filters, setFilters] = useState<Shop>(shopsFilters);

    const [getShops, { data: shops, isFetching, isLoading, isSuccess }] =
        useLazyReadShopsQuery();
    const [tab, setTab] = useState(
        sessionStorage.getItem(pageSlug) || 'visitors'
    );

    const current = useAppSelector(selectShopCurrent);

    useEffect(() => {
        if (filters) {
            getShops(filters, false);
        }
    }, [filters]);

    useEffect(() => {
        sessionStorage.setItem(pageSlug, tab);
        navigate(`${getEnvConfig().PUBLIC_PATH}/crm/${tab}`);
    }, [tab]);

    useEffect(() => {
        if (location.pathname.includes('exports')) {
            return setTab('exports');
        }

        if (
            location.pathname.includes('orders') &&
            (current?.type === 1 || current?.type === 2)
        ) {
            return setTab('visitors');
        }
    }, [location, current]);

    const isShops = !!shops?.items;
    const isTelegramAccount = user?.telegram_accounts?.length > 0;

    if (!isTelegramAccount && isShops) return <ExampleShopCard />;

    return (
        <Page title='CRM'>
            <ShopSelector {...current} />

            <Tabs
                activeKey={tab}
                onChange={setTab}
                items={getTabs(
                    current?.type === 1 || current?.type === 2
                ).filter(item => !item.disabled)}
            />
            <Outlet />
        </Page>
    );
};
